<template>
    <div>
    <b-card no-body>
      <b-card-header>
        <b>External Ids</b>
        <b-button
          type="button"
          variant="outline-primary"
          size="sm"
          class="float-right"
          @click="toggleModal"
          :disabled="!isAllowedToCreateOrEditPerson"
        >
          <span class="button-text">Add Ext Id</span>
        </b-button>
      </b-card-header>

      <!-- List groups and sharing status -->
      <div v-if="personExternalIds.length > 0">
        <b-list-group v-for="extId in personExternalIds" :key="extId.id" flush>
          <b-list-group-item>
            <a href="" @click.prevent>{{ _.get(extId, 'externalId', 'Unknown') }} ({{ _.get(extId, 'eorganization.title')}})</a>
          </b-list-group-item>
        </b-list-group>
      </div>

      <div v-if="personExternalIds.length === 0">
        <b-list-group flush>
          <b-list-group-item>
            <p>No External Ids</p>
          </b-list-group-item>
        </b-list-group>
      </div>
    </b-card>

    <b-modal
      title="Add External Id"
      header-bg-variant="success"
      header-text-variant="light"
      size="lg"
      :visible="modalVisible"
      centered
      @hide="resetResponse"
      @ok="add"
    >
      <b-form>
        <b-form-group label="External Id" label-for="extid">
          <b-form-input size="lg" type='text' name="extid" v-model="form.externalId"></b-form-input>
        </b-form-group>
      </b-form>
      <b-alert
        dismissible
        fade
        :show="!_.isEmpty(createExternalIdResponse.body)"
        :variant="createExternalIdResponse.ok ? 'success' : 'danger'"
      >
        <span v-html="apiResponseMessage(createExternalIdResponse)"></span>
      </b-alert>
      <template #modal-footer>
        <div class="w-100">
          <b-button
            variant="primary"
            size="sm"
            class="float-right"
            @click="add"
          >
            Submit
          </b-button>
          <b-button
            variant="link"
            size="sm"
            class="float-right"
            @click="toggleModal"
          >
            Cancel
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'person-externalids',
  props: {
    personId: Number,
    isAllowedToCreateOrEditPerson: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      modalVisible: false,
      form: {
        externalId: null
      }
    }
  },
  computed: {
    ...mapGetters({
      personExternalIds: 'personExternalIds',
      createExternalIdResponse: 'createExternalIdResponse', // TO DO - Expose this somewhere
      userCurrentContext: 'userCurrentContext'
    })
  },
  watch: {
    personId: function (newValue) {
      if (newValue && _.isInteger(newValue)) {
        this.$store.dispatch('getPersonExternalIds', {
          eperson: newValue,
          populate: 'eorganization'
        })
      }
    }
  },
  methods: {
    toggleModal: function () {
      this.modalVisible = !this.modalVisible
      this.form.externalId = ''
    },
    add: function (group) {
      const eperson = this.personId
      const eorganization = _.get(this, 'userCurrentContext.organization.id', false)
      const externalId = this.form.externalId

      if (!eperson || !eorganization || !externalId) {
        this.$store.commit('SET_ADD_EXTERNAL_ID_RESPONSE', { success: false, error: { code: 'INVALID_API_CALL', message: 'Invalid Parameters' } })
        return
      }

      if (eperson && eorganization && externalId) {
        this.$store.dispatch('createExternalId', {
          eperson,
          eorganization,
          externalId
        })
      }
    },
    apiResponseMessage: function (response) {
      let message = response.statusText

      if (!response.ok && (response.error || response.body)) {
        message = this.$utils.errorToHtml(response.error || response.body)
      }

      if (response.body && response.body.message) {
        message = response.body.message
      }

      if (response.ok) {
        message = 'Success!'
        setTimeout(() => {
          this.modalVisible = false
        }, 1000)
      }

      message = '<p>' + message + '</p>'
      return message
    },
    resetResponse: function () {
      this.$store.commit('RESET_CREATE_EXTERNAL_ID_RESPONSE')
    },
    resetAll: function () {
      this.$store.commit('RESET_SHARE_PERSON_RECORDS')
      this.$store.commit('RESET_CREATE_EXTERNAL_ID_RESPONSE')
    }
  },
  created () {
    this.$store.dispatch('getPersonExternalIds', {
      eperson: this.personId,
      populate: 'eorganization'
    })
  },
  beforeDestroy () {
    this.resetAll()
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Person/PersonExternalIds.vue